import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-hs-apply-now.component.scss';
var FormItemHsApplyNow = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemHsApplyNow, _super);
    function FormItemHsApplyNow(element) {
        var _this = _super.call(this, element) || this;
        _this.questions = [];
        return _this;
    }
    FormItemHsApplyNow.prototype.init = function () {
        this.formLoader = this.element.querySelector(".form__loader--container");
        this.formFields = this.element.querySelector(".form__fields--container");
        this.formThankyou = this.element.querySelector(".form__thankyou--container");
        this.formSurvey = this.element.querySelector(".form__survey--container");
        this.formSurveyMessag = this.element.querySelector(".form__survey--message");
        this.form = this.element.querySelector('form');
        this.steps = Array.from(this.element.querySelectorAll(".hs-apply-now__steps--step[data-step]"));
        this.survey = this.element.querySelector(".form__survey--container");
        this.buttonSubmit = this.element.querySelector('.js_step-submit-button');
        this.stepButtons = Array.from(this.element.querySelectorAll(".js_step-button"));
        this.surveyButton = this.element.querySelector(".js_survey-button");
        this.hidLeadId = this.form.querySelector('input[name=leadId]');
        this.hidProduct = this.form.querySelector('input[name=product]');
        this.wizardCount = this.element.querySelector(".hs-apply-now__counter--count");
        this.bulletContainer = this.element.querySelector(".hs-apply-now__bullets");
        this.applicationType = this.element.querySelector(".js-apply-now-app-type");
        this.businessFields = Array.from(this.element.querySelectorAll(".js-hs-apply-now-vissible-business"));
        this.jointFields = Array.from(this.element.querySelectorAll(".js-hs-apply-now-vissible-joint"));
        this.applicantAdd = this.element.querySelector(".js-hs-apply-now-add-applicant");
        this.totalSteps = this.element.querySelector('input[name="total-steps"]');
        this.totalSteps.nodeValue = this.steps.length.toString();
        this.showStep(1);
        if (this.applicationType) {
            this.updateForm(this.applicationType.value);
        }
    };
    FormItemHsApplyNow.prototype.bindEvents = function () {
        var _this = this;
        if (this.surveyButton) {
            this.surveyButton.addEventListener('click', function (event) {
                if (_this.survey) {
                    _this.getSurveyQuestions();
                }
            });
        }
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener('click', function (event) {
                var formFields = _this.form.querySelectorAll('input, select, textarea');
                var validation = _this.validationService.validate(formFields);
                var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
                if (valid.length == 0) {
                    _this.actionForm(_this.form);
                }
            });
        }
        if (this.stepButtons.length) {
            this.stepButtons.map(function (item) { return item.addEventListener('click', function (event) {
                var _event = event.currentTarget;
                var _currentStep = _event.closest(".hs-apply-now__steps--step");
                var _steps = Array.from(_this.element.querySelectorAll(".hs-apply-now__steps--step"));
                if (!_currentStep.classList.contains("hs-apply-now__steps--hidden")) {
                    var formFields = _currentStep.querySelectorAll('input, select, textarea');
                    var validation = _this.validationService.validate(formFields);
                    var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
                    if (valid.length == 0) {
                        _this.showNextStep(event);
                    }
                }
            }); });
        }
        if (this.applicationType) {
            this.applicationType.addEventListener('change', function (event) {
                _this.updateForm(_this.applicationType.value);
            });
        }
        if (this.applicantAdd) {
            this.applicantAdd.addEventListener('click', function (event) {
                _this.addCoApplicant();
            });
        }
        // Reset the form
        this.form.addEventListener('custom_form_reset_event', function (e) {
            _this.showStep(1);
            _this.formSurvey.innerHTML = "";
            _this.formSurvey.classList.remove("active");
            _this.formSurveyMessag.classList.remove('active');
            var _formName = _this.form.getAttribute("data-frmcontainer");
            _formName = _formName.replace(" survey");
            _this.form.setAttribute("data-frmcontainer", _formName);
        }, false);
    };
    FormItemHsApplyNow.prototype.showStep = function (stepId) {
        var _this = this;
        var _listItems = document.createElement('ul');
        _listItems.classList.add("hs-apply-now__bullets-container");
        if (this.steps) {
            this.steps.forEach(function (element, index) {
                var _step = element.getAttribute("data-step");
                var _listItem = document.createElement('li');
                if ((parseFloat(_step) == stepId)) {
                    element.classList.remove("hs-apply-now__steps--hidden");
                    _listItem.classList.add("hs-apply-now__bullets-container--bullet-active");
                }
                else {
                    element.classList.add("hs-apply-now__steps--hidden");
                    _listItem.classList.add("hs-apply-now__bullets-container--bullet");
                }
                _listItem.innerHTML = "&bull;";
                _listItems.appendChild(_listItem);
                if (index < (_this.steps.length - 1)) {
                    var _listPipe = document.createElement('li');
                    _listPipe.classList.add("hs-apply-now__bullets-container--bullet");
                    _listPipe.innerHTML = "|";
                    _listItems.appendChild(_listPipe);
                }
            });
        }
        this.wizardCount.innerHTML = stepId + "/" + parseFloat(this.totalSteps.getAttribute('value'));
        this.bulletContainer.innerHTML = "";
        this.bulletContainer.appendChild(_listItems);
        this.updateForm(this.applicationType.value);
    };
    FormItemHsApplyNow.prototype.showNextStep = function (event) {
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.wizardCount.innerHTML = parseFloat(_nextStep) + 1 + "/" + parseFloat(this.totalSteps.getAttribute('value'));
        this.showStep(parseFloat(_nextStep) + 1);
    };
    FormItemHsApplyNow.prototype.updateForm = function (type) {
        if (this.businessFields) {
            this.businessFields.forEach(function (elem) {
                var _group = elem.closest(".form__group ");
                if (type == 'B') {
                    elem.classList.add("form__input--required");
                    _group.classList.remove("form__group--hidden");
                }
                else {
                    elem.classList.remove("form__input--required");
                    _group.classList.add('form__group--hidden');
                }
            });
        }
        if (this.jointFields) {
            this.jointFields.forEach(function (elem) {
                var _group = elem.closest(".form__group");
                if (type == 'J') {
                    elem.classList.add("form__input--required");
                    _group.classList.remove("form__group--hidden");
                }
                else {
                    elem.classList.remove("form__input--required");
                    _group.classList.add('form__group--hidden');
                }
            });
        }
        if (type != 'J') {
            this.applicantAdd.classList.remove('link--disabled');
            var _coAppParent = this.element.querySelector(".form__coapp--parent");
            if (_coAppParent) {
                _coAppParent.remove();
            }
        }
    };
    FormItemHsApplyNow.prototype.addCoApplicant = function () {
        var _parentExists = false;
        var _childCount = false;
        var _parent = this.applicantAdd.closest(".form__group");
        var _coAppParent = this.element.querySelector(".form__coapp--parent");
        if (!_coAppParent) {
            _coAppParent = document.createElement("div");
            _coAppParent.classList.add("form__coapp--parent");
            _parentExists = true;
            _childCount = true;
        }
        else {
            _parentExists = true;
            var _coAppChild_1 = Array.from(this.element.querySelectorAll(".form__coapp--child"));
            if (_coAppChild_1.length < 5) {
                _childCount = true;
            }
            else {
                _childCount = false;
            }
        }
        if (_parentExists && _childCount) {
            var _guid = this.guidGenerator();
            var _coApplicantChild = document.createElement("div");
            _coApplicantChild.classList.add("form__coapp--child");
            _coApplicantChild.setAttribute("data-coapp", _guid);
            var _name = this.createElement('text', 'first-name', 'Co-App First Name', ['form__input--required']);
            var _surname = this.createElement('text', 'last-name', 'Co-App Surname', ['form__input--required']);
            var _identityNumber = this.createElement('text', 'identification-number', 'Co-App Identity number', ['form__input--required', 'form__input--identification']);
            var _contactNumber = this.createElement('text', 'contact-details', 'Co-App Contact details', ['form__input--required', 'form__input--contact']);
            var _remApplicant = this.createElement('link', 'removeApp', '<span class="link__text" data-modal=""> - Remove Co-Applicant </span>', ['js-hs-apply-now-rem-applicant']);
            _coApplicantChild.appendChild(_name);
            _coApplicantChild.appendChild(_surname);
            _coApplicantChild.appendChild(_identityNumber);
            _coApplicantChild.appendChild(_contactNumber);
            _coApplicantChild.appendChild(_remApplicant);
            _coAppParent.appendChild(_coApplicantChild);
            _parent.append(_coAppParent);
        }
        var _coAppChild = Array.from(this.element.querySelectorAll(".form__coapp--child"));
        if (_coAppChild.length < 5) {
            this.applicantAdd.classList.remove('link--disabled');
        }
        else {
            this.applicantAdd.classList.add('link--disabled');
        }
    };
    FormItemHsApplyNow.prototype.remCoApplicant = function (event) {
        var _children = Array.from(this.element.querySelectorAll(".form__coapp--child"));
        if (_children.length > 1) {
            var _target = event.currentTarget.closest(".form__coapp--child");
            _target.remove();
        }
        else {
            var _parent = this.element.querySelector(".form__coapp--parent");
            _parent.remove();
        }
        this.applicantAdd.classList.remove('link--disabled');
    };
    FormItemHsApplyNow.prototype.createElement = function (type, inputName, label, modifiers) {
        var _this = this;
        var _a;
        var _div = document.createElement('div');
        _div.classList.add("form__group");
        var _input;
        if (type == 'text') {
            var _label = document.createElement("label");
            _label.classList.add("form__label");
            _label.innerText = label;
            _input = document.createElement("input");
            _input.type = type;
            _input.name = inputName;
            _input.classList.add("form__input");
            (_a = _input.classList).add.apply(_a, modifiers);
            _div.appendChild(_label);
            _div.appendChild(_input);
        }
        else if (type == 'link') {
            var _wrapper = document.createElement('div');
            _wrapper.classList.add("form__link");
            _wrapper.classList.add("hs-apply-now__form-link");
            _input = document.createElement("a");
            _input.href = 'javascript:void(0);';
            _input.setAttribute("data-id", "link_content_apply now remove applicant");
            _input.setAttribute("data-text", "home services | apply now | remove co-applicant button click");
            _input.classList.add("link");
            _input.innerHTML = label;
            _input.classList.add(modifiers);
            _wrapper.appendChild(_input);
            _div.appendChild(_wrapper);
            _input.addEventListener('click', function (event) {
                _this.remCoApplicant(event);
            });
        }
        return _div;
    };
    FormItemHsApplyNow.prototype.guidGenerator = function () {
        var S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    };
    FormItemHsApplyNow.prototype.actionForm = function (form) {
        var _this = this;
        var _records = [];
        var name = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        // paremeters
        var _type = this.form.querySelector('select[name=applyType]');
        var _address = this.form.querySelector('input[name=address]');
        var _city = this.form.querySelector('input[name=city]');
        var _suburb = this.form.querySelector('input[name=suburb]');
        var _areaCode = this.form.querySelector('input[name=areaCode]');
        var _loanAmount = this.form.querySelector('input[name=loanAmount]');
        var _businessName = this.form.querySelector('input[name=businessName]');
        var _businessRegNumber = this.form.querySelector('input[name=businessRegNumber]');
        var _selfEmployed = this.form.querySelector('select[name=self-employed]');
        var _newOrFurther = this.form.querySelector('select[name=loan-type]');
        var _name = this.form.querySelector('input[name=firstName]');
        var _surname = this.form.querySelector('input[name=lastName]');
        var _idNumber = this.form.querySelector('input[name=identificationNumber]');
        var _contactNumber = this.form.querySelector('input[name=contactDetails]');
        _records.push({
            "firstName": _name.value,
            "lastName": _surname.value,
            "identificationNumber": _idNumber.value,
            "contactDetails": _contactNumber.value,
            "consent": "Y",
            "declaration": "Y"
        });
        var _coAppParent = this.element.querySelector(".form__coapp--parent");
        if (_coAppParent && (_type.value == 'J')) {
            var _coApps = Array.from(this.element.querySelectorAll('.form__coapp--child'));
            if (_coApps.length) {
                _coApps.forEach(function (coApp) {
                    var _name = coApp.querySelector('input[name=first-name]');
                    var _surname = coApp.querySelector('input[name=last-name]');
                    var _idNumber = coApp.querySelector('input[name=identification-number]');
                    var _contactNumber = coApp.querySelector('input[name=contact-details]');
                    _records.push({
                        "firstName": _name.value,
                        "lastName": _surname.value,
                        "identificationNumber": _idNumber.value,
                        "contactDetails": _contactNumber.value,
                        "consent": "",
                        "declaration": ""
                    });
                });
            }
        }
        var _form = {
            "applyType": _type.value,
            "selfEmployed": _selfEmployed.value,
            "newOrFurther": _newOrFurther.value,
            "address": _address.value,
            "city": _city.value,
            "suburb": _suburb.value,
            "areaCode": _areaCode.value,
            "loanAmount": _loanAmount.value,
            "businessName": _businessName.value,
            "businessRegNumber": _businessRegNumber.value,
            "recordCount": _records.length,
            "records": _records
        };
        var postData = '';
        postData += 'actionname=applynow&';
        postData += 'applyNowformJSONData=' + JSON.stringify(_form);
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        this.formLoader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/homeservices/sbhsapplynow";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            _this.formLoader.classList.remove('active');
            if (!response.data) {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                _this.formLoader.classList.remove('active');
                fieldsContainer.classList.remove('hidden');
            }
            else {
                name.map(function (_item) {
                    _item.innerHTML = _name.value;
                });
                analyticsService.dtmFormComplete('complete', response.code);
                _this.formLoader.classList.remove('active');
                _this.formThankyou.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            _this.formLoader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    FormItemHsApplyNow.prototype.getSurveyQuestions = function () {
        var _this = this;
        var _formName = this.form.getAttribute("data-frmcontainer");
        this.form.setAttribute("data-frmcontainer", _formName + " survey");
        this.analyticsService.dtmRestartForm();
        // loader + hide form
        this.formLoader.classList.add('active');
        this.formLoader.classList.remove('hidden');
        this.formThankyou.classList.add('hidden');
        this.formThankyou.classList.remove('active');
        var postData = 'actionname=getQuestionsWithSurveyId' + '&' + 'applySurveyformJSONData=Y' + '&' + 'srvNo=1';
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/homeservices/sbhsapplysurvey";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            _this.formLoader.classList.remove('active');
            if (!response.data || (response.data.code != '0000')) {
                _this.formLoader.classList.remove('active');
                _this.formThankyou.classList.remove('hidden');
                _this.formThankyou.classList.add('active');
            }
            else {
                _this.questions = response.data.questions;
                _this.createSurvey(response.data.questions);
                _this.formLoader.classList.remove('active');
                _this.formSurvey.classList.add('active');
                _this.formSurvey.setAttribute("data-survey", response.data.apsrvId);
                _this.formSurvey.setAttribute("data-surveyNo", "1");
                _this.formSurvey.setAttribute("data-surveyId", response.data["tran-id"]);
            }
        }).catch(function (response) {
            // service failed
            _this.formLoader.classList.remove('active');
            _this.formThankyou.classList.remove('hidden');
            _this.formThankyou.classList.add('active');
        });
    };
    FormItemHsApplyNow.prototype.createSurvey = function (questions) {
        var _this = this;
        if (questions && questions != undefined) {
            questions.forEach(function (question) {
                var _element = null;
                if (question.type == 1) {
                    _element = _this.createRadioButton(question);
                }
                else if (question.type == 2) {
                    _element = _this.createTextField(question);
                }
                if (_element) {
                    _this.formSurvey.appendChild(_element);
                }
            });
            this.formSurvey.appendChild(this.createButton());
        }
    };
    FormItemHsApplyNow.prototype.createRadioButton = function (object) {
        var _this = this;
        var _group = document.createElement('div');
        _group.classList.add("form__group");
        _group.setAttribute("data-question", object.questionCode);
        var _wrapper = document.createElement('div');
        _wrapper.classList.add('apply-now__radio');
        var _radioLabel = document.createElement("label");
        _radioLabel.classList.add("form__label");
        _radioLabel.innerText = object.label;
        _wrapper.appendChild(_radioLabel);
        // object.group.forEach(_element => {
        var _label1 = document.createElement("label");
        _label1.classList.add("form__control", "form__control--radio");
        _label1.innerText = "Yes";
        var _radio1 = document.createElement("input");
        _radio1.setAttribute("type", "radio");
        _radio1.setAttribute("name", object.name);
        _radio1.setAttribute("value", "Y");
        _radio1.addEventListener('change', function (event) {
            var _input = event.currentTarget;
            var name = _radio1.getAttribute("name");
            var div = _this.element.querySelector("[name=" + name + "-textdiv]");
            if (object.condition == 1) {
                div.classList.remove("form__group--hidden");
            }
            else {
                div.classList.add("form__group--hidden");
            }
        });
        var _indicator1 = document.createElement('div');
        _indicator1.classList.add("form__control-indicator");
        _label1.appendChild(_radio1);
        _label1.appendChild(_indicator1);
        _wrapper.appendChild(_label1);
        // });
        var _label2 = document.createElement("label");
        _label2.classList.add("form__control", "form__control--radio");
        _label2.innerText = "No";
        var _radio2 = document.createElement("input");
        _radio2.setAttribute("type", "radio");
        _radio2.setAttribute("name", object.name);
        _radio2.setAttribute("value", "N");
        _radio2.addEventListener('change', function (event) {
            var _input = event.currentTarget;
            var name = _radio2.getAttribute("name");
            var div = _this.element.querySelector("[name=" + name + "-textdiv]");
            if (object.condition == 2) {
                div.classList.remove("form__group--hidden");
            }
            else {
                div.classList.add("form__group--hidden");
            }
        });
        var _indicator2 = document.createElement('div');
        _indicator2.classList.add("form__control-indicator");
        _label2.appendChild(_radio2);
        _label2.appendChild(_indicator2);
        _wrapper.appendChild(_label2);
        var _whygroup = document.createElement('div');
        _whygroup.classList.add("form__group");
        _whygroup.setAttribute("name", object.name + "-textdiv");
        var _label = document.createElement("label");
        _label.classList.add("form__label");
        _label.innerText = object.caseQuestion;
        var _textBox = document.createElement("input");
        _textBox.classList.add("form__input", "form__input--required");
        _textBox.setAttribute("type", "text");
        _textBox.setAttribute("name", object.name + "-text");
        _textBox.setAttribute("value", "");
        _label.appendChild(_textBox);
        _whygroup.appendChild(_label);
        _whygroup.classList.add('form__group--hidden');
        _group.appendChild(_wrapper);
        _group.appendChild(_whygroup);
        return _group;
    };
    FormItemHsApplyNow.prototype.createTextField = function (object) {
        var _group = document.createElement('div');
        _group.classList.add("form__group");
        _group.setAttribute("data-question", object.questionCode);
        var _wrapper = document.createElement('div');
        _wrapper.classList.add('apply-now__radio');
        var _label = document.createElement("label");
        _label.classList.add("form__label");
        _label.innerText = object.label;
        var _textBox = document.createElement("input");
        _textBox.classList.add("form__input", "form__input--required");
        _textBox.setAttribute("type", "text");
        _textBox.setAttribute("name", object.name);
        _textBox.setAttribute("value", "");
        // _textBox.setAttribute("placeholder", object.placeholder);
        _label.appendChild(_textBox);
        _wrapper.appendChild(_label);
        _group.appendChild(_wrapper);
        return _group;
    };
    FormItemHsApplyNow.prototype.createButton = function () {
        var _this = this;
        var _wrapper = document.createElement('div');
        _wrapper.classList.add("apply-now__buttons");
        var _button = document.createElement("button");
        _button.classList.add("button", "button--medium", "apply-now__button", "js_survey-button");
        _button.setAttribute("type", "button");
        _button.setAttribute("data-id", "link_content_survey button");
        _button.setAttribute("data-text", "home services | apply now | survey submit button click");
        _button.innerText = "Submit";
        _button.addEventListener('click', function (event) {
            _this.submitSurveyQuestions(event);
        });
        _wrapper.appendChild(_button);
        return _wrapper;
    };
    FormItemHsApplyNow.prototype.submitSurveyQuestions = function (object) {
        var _this = this;
        var _answers = [];
        if (this.questions && this.questions != undefined) {
            this.questions.forEach(function (question) {
                // let inputElement: Element = this.element.querySelector("[name=" + question.name + "]")as HTMLFormElement;
                if (question.type == 1) {
                    var inputElement = _this.formSurvey.querySelector("input[name=" + question.name + "]:checked");
                    var answer = "";
                    if (inputElement != null) {
                        answer = inputElement.value;
                        var inputElement1 = _this.formSurvey.querySelector("input[name=" + question.name + "-text]");
                        var comment = "";
                        if (inputElement1 != null) {
                            comment = inputElement1.value;
                        }
                        _answers.push({
                            "answer": answer,
                            "questionCode": question.questionCode,
                            "comment": comment
                        });
                    }
                    else {
                        _answers.push({
                            "answer": "",
                            "comment": "",
                            "questionCode": question.questionCode
                        });
                    }
                }
                else if (question.type == 2) {
                    var inputElement = _this.formSurvey.querySelector("input[name=" + question.name + "]");
                    var answer = "";
                    if (inputElement != null) {
                        answer = inputElement.value;
                    }
                    _answers.push({
                        "answer": answer,
                        "questionCode": question.questionCode,
                        "comment": answer
                    });
                }
            });
        }
        var data = {
            "aplsrvId": this.formSurvey.getAttribute("data-survey"),
            "srvNo": this.formSurvey.getAttribute("data-surveyNo"),
            "reqVisitorId": this.analyticsService.getDtmVisitorID(),
            "reqTranId": this.formSurvey.getAttribute("data-surveyId"),
            "reqFeature": "",
            "ansCount": _answers.length,
            "answersArray": _answers
        };
        var postData = 'actionname=postAnswers' + '&' + 'applySurveyformJSONData=' + JSON.stringify(data);
        var url = "/homeservices/sbhsapplysurvey";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            _this.formLoader.classList.remove('active');
            _this.formSurvey.classList.remove('active');
            _this.formSurveyMessag.classList.add('active');
            if (!response.data || (response.data.code != '0000')) {
                _this.analyticsService.dtmFormComplete('complete', response['tran-id']);
            }
            else {
                _this.analyticsService.dtmFormComplete('complete', 'fail');
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
            _this.formLoader.classList.remove('active');
            _this.formSurvey.classList.remove('active');
            _this.formSurveyMessag.classList.add('active');
        });
    };
    return FormItemHsApplyNow;
}(Base));
export { FormItemHsApplyNow };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-hs-apply-now/form-item-hs-apply-now.component.ts
// module id = 903
// module chunks = 0